/** Header of an open idea thread: back-to-board, title, and the status selector. */
export function IdeaThreadHeader({
  title,
  status,
  onBack,
  onStatusChange,
}: {
  title: string;
  status: string;
  onBack: () => void;
  onStatusChange: (status: string) => void;
}) {
  return (
    <div className="idea-head">
      <button className="back" onClick={onBack}>
        ‹ Board
      </button>
      <span className="idea-title">{title}</span>
      <select className={`status-select ${status}`} value={status} onChange={(e) => onStatusChange(e.target.value)}>
        {["draft", "ready", "in_progress", "done", "rejected"].map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </div>
  );
}
